if (!customElements.get('aogeo-solutions-menu')) {
  class AogeoSolutionsMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;

      const groupTabs = Array.from(this.querySelectorAll('[data-group-tab]'));
      const groupPanels = Array.from(this.querySelectorAll('[data-group-panel]'));
      if (!groupTabs.length || groupTabs.length !== groupPanels.length) return;

      const childState = new Map();
      let activeGroupIndex = -1;
      this.dataset.enhanced = 'true';

      const normalizeIndex = (requestedIndex, length) => {
        return ((requestedIndex % length) + length) % length;
      };

      const activateChild = (groupIndex, requestedIndex, moveFocus) => {
        const groupPanel = groupPanels[groupIndex];
        if (!groupPanel) return;

        const childTabs = Array.from(groupPanel.querySelectorAll('[data-child-tab]'));
        const childPanels = Array.from(groupPanel.querySelectorAll('[data-child-panel]'));
        if (!childTabs.length || childTabs.length !== childPanels.length) return;

        const safeIndex = normalizeIndex(requestedIndex, childTabs.length);
        if (childState.get(groupIndex) === safeIndex && !moveFocus) return;
        childState.set(groupIndex, safeIndex);

        childTabs.forEach((tab, index) => {
          const active = index === safeIndex;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        childPanels.forEach((panel, index) => {
          const active = index === safeIndex;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        if (moveFocus) childTabs[safeIndex].focus();
      };

      const activateGroup = (requestedIndex, moveFocus) => {
        const safeIndex = normalizeIndex(requestedIndex, groupTabs.length);
        if (activeGroupIndex === safeIndex && !moveFocus) return;
        activeGroupIndex = safeIndex;

        groupTabs.forEach((tab, index) => {
          const active = index === safeIndex;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        groupPanels.forEach((panel, index) => {
          const active = index === safeIndex;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        activateChild(safeIndex, childState.get(safeIndex) || 0, false);
        if (moveFocus) groupTabs[safeIndex].focus();
      };

      groupTabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') activateGroup(index, false);
        });

        tab.addEventListener('focus', () => activateGroup(index, false));
        tab.addEventListener('click', () => activateGroup(index, false));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = index + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = index - 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = groupTabs.length - 1;

          if (nextIndex !== null) {
            event.preventDefault();
            activateGroup(nextIndex, true);
          }
        });
      });

      groupPanels.forEach((groupPanel, groupIndex) => {
        const childTabs = Array.from(groupPanel.querySelectorAll('[data-child-tab]'));
        const childPanels = Array.from(groupPanel.querySelectorAll('[data-child-panel]'));
        if (!childTabs.length || childTabs.length !== childPanels.length) return;

        childTabs.forEach((tab, index) => {
          tab.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') activateChild(groupIndex, index, false);
          });

          tab.addEventListener('focus', () => activateChild(groupIndex, index, false));
          tab.addEventListener('click', () => activateChild(groupIndex, index, false));

          tab.addEventListener('keydown', (event) => {
            let nextIndex = null;
            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = index + 1;
            if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = index - 1;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = childTabs.length - 1;

            if (nextIndex !== null) {
              event.preventDefault();
              activateChild(groupIndex, nextIndex, true);
            }
          });
        });

        const selectedChild = childTabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        activateChild(groupIndex, selectedChild >= 0 ? selectedChild : 0, false);
      });

      const selectedGroup = groupTabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      activateGroup(selectedGroup >= 0 ? selectedGroup : 0, false);
    }
  }

  customElements.define('aogeo-solutions-menu', AogeoSolutionsMenu);
}
